import { useEntity } from '@backstage/plugin-catalog-react';
import { ZpaEditIcon } from './ZpaEditIcon';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import { DocsIcon, StructuredMetadataTable } from '@backstage/core-components';
import _ from 'lodash';

import { useStyles } from '../styles';
import { CpeCardProps, Features } from '../types';

export function ZpaCard(props: CpeCardProps) {
  const { variant } = props;
  const classes = useStyles();
  const { entity } = useEntity();
  const features: Features | undefined = entity?.spec?.features as
    | Features
    | undefined;

  let cardClass = '';
  let cardContentClass = '';
  if (variant === 'gridItem') {
    cardClass = classes.gridItemCard;
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    cardClass = classes.fullHeightCard;
    cardContentClass = classes.fullHeightCardContent;
  }

  const EditZpaIcon = () => {
    return (
      <CardActions>
        <Tooltip title="Learn more about remote access using ZPA">
          <IconButton
            href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/infrastructure/aws/foundation-managed-vpc/#remote-access-using-zscaler-private-access"
            target="_blank"
          >
            <DocsIcon />
          </IconButton>
        </Tooltip>
        <ZpaEditIcon
          variant={variant}
          classes={classes}
          entity={entity}
          features={features}
        />
      </CardActions>
    );
  };

  return (
    <Card className={cardClass}>
      <CardHeader
        title="Zscaler Private Access"
        titleTypographyProps={{ component: 'h2' }}
        variant={variant}
        action={<EditZpaIcon />}
      />
      <Divider />
      <CardContent className={cardContentClass}>
        <StructuredMetadataTable
          metadata={{
            Status: features?.zpa?.enabled ? 'Enabled' : 'Disabled',
          }}
        />
      </CardContent>
    </Card>
  );
}
